import React from 'react';
import { Hero, MiniCtaGroup } from '@greystar/designsystem';
import FlexibleHeroProps from './FlexibleHero.props';
import FlexibleHeroWrapper from './FlexibleHeroWrapper';
import Image from 'next/image';
import { PROPERTY_CARD_FALLBACK_IMAGE_URL } from '@greystar/lib';

const FlexibleHeroNoText = (props: FlexibleHeroProps) => {
  const img = props.image ?? (
    <Image
      alt={'No image placeholder'}
      loading="lazy"
      fill
      src={PROPERTY_CARD_FALLBACK_IMAGE_URL}
    />
  );
  return (
    <FlexibleHeroWrapper {...props}>
      <Hero Hero hasPadding={props.bodyTextIndentation}>
        <Hero.Tags>
          <MiniCtaGroup ctas={props.SxaTags ?? []} />
        </Hero.Tags>
        <Hero.Image>{img}</Hero.Image>
      </Hero>
    </FlexibleHeroWrapper>
  );
};

export default FlexibleHeroNoText;
